import React from "react";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { toaster } from "../../actions/showToast";

export default function AddBlankPage(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const onClickAddBlankPage = () => {
    // console.log("--Add a note..", props);
    dispatch(toaster(t("Click a point to add a page"), "warning"));
    props.changeMyTool("addblankpage");
  };
  return (
    <li onClick={onClickAddBlankPage}>
      <span
        className={`button normal-btn next-page ${
          props.shouldShowButtonLabels ? "show-label-span" : ""
        } ${
          props.activeButton === "addblankpage" ? "active" : ""
        }`}
        title={t("Add Blank Page")}
        data-tip={t("Add Blank Page")}
      >
        <img
          src={require("../../assets/img/svg/tools-add-blank-page.svg")}
          alt={t("Add Blank Page")}
        />
        {props.shouldShowButtonLabels && <span className="show-label-text">{t("Page")}</span>}
      </span>
    </li>
  );
}
